import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Markdown from 'react-markdown';
import ShadowDOM from 'react-shadow';
import remarkGfm from 'remark-gfm';
export const MarkdownViewer = ({ markdown, className }) => {
    return (_jsxs(ShadowDOM.div, { className: className, children: [_jsx("style", { children: `
          table {
            border-collapse: collapse;
          }
          th, td {
            border: 1px solid #ccc;
            padding: 8px;
            text-align: left;
          }
          th {
            background: #f0f0f0;
          }
        ` }), _jsx("div", { children: _jsx(Markdown, { remarkPlugins: [remarkGfm], children: markdown ?? '' }) })] }));
};
